import { getEnumObject } from '../utilities.js';

export const communicationLanguages = {
  ARABIC: 'ar',
  ENGLISH: 'en',
};

export default getEnumObject(communicationLanguages);
